import React from 'react';
import { IColorScheme, colorSchemes } from '../logic/text-test-logic';
import '../styles/color-picker.scss';
import { isEnter } from '../../shared/util/functions';

interface Props {
    fontFamily: string;
    onSchemeChange: (pickedScheme: IColorScheme) => void;
    current: IColorScheme;
}

function getBox(
    txtColor: string,
    fontFamily: string,
    bgColor: string,
    boxId: number,
    onClick: (pickedScheme: IColorScheme) => void,
    current: IColorScheme,
    label: string
): any {
    const isActive = current.txtColor === txtColor && current.bgColor === bgColor;
    

    return (
        <div
            key={boxId}
            tabIndex={0}
            aria-label={label}
            style={{ backgroundColor: bgColor }}
            className={'color-picker__box ' + (isActive && 'color-picker__active')}
            onKeyPress={evt => isEnter(evt) && onClick({ txtColor, bgColor, label })}
            onClick={() => onClick({ txtColor, bgColor, label })}
        >
            <span className={'color-picker__box__symbol'} style={{ color: txtColor, fontFamily }}>A</span>
        </div>
    );
}

export const ColorPicker: React.FunctionComponent<Props> = props => {
    const boxes = colorSchemes.map((scheme: IColorScheme, i: number) =>
        getBox(scheme.txtColor, props.fontFamily, scheme.bgColor, i, props.onSchemeChange, props.current, scheme.label)
    );
    return (
        <div className={'color-picker--wrapper'}>
            {boxes}
        </div>
    );
};

